import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { cssProperties } from "../utils/commonCssProperties";

const cellStyle = {
  overflow: "hidden",
  wordWrap: "break-word",
  whiteSpace: "nowrap",
  textAlign: "center",
};

const headerCellStyle = {
  ...cellStyle,
  fontWeight: "bold",
};

export default function VBSATable({
  tableData = [],
  columnData = [],
}) {
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    setRows(tableData);
  }, [tableData]);

  /* ================= TOTAL ROW ================= */
  const totalRow = React.useMemo(() => {
    if (!rows.length) return null;

    const totals = {};

    columnData.forEach((col) => {
      const key = col.dataIndex;
      totals[key] = rows.reduce((sum, r) => sum + (Number(r[key]) || 0), 0);
    });

    return totals;
  }, [rows, columnData]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        background: "none",
        border: `1px solid ${cssProperties.bordercolor.primary2blue}`,
        boxShadow: "none",
      }}
    >
      <Table aria-label="preference wise table">
        {/* ================= HEADER ================= */}
        <TableHead>
          <TableRow>
            {columnData.map((col, index) => (
              <TableCell
                key={index}
                align="center"
                sx={{
                  color: cssProperties.bordercolor.primary2blue,
                  borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                  ...headerCellStyle,
                }}
              >
                {col.name}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {/* ================= BODY ================= */}
        <TableBody>
          {rows.length > 0 ? (
            <>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columnData.map((col, colIndex) => (
                    <TableCell
                      key={`${rowIndex}-${colIndex}`}
                      align="center"
                      sx={{
                        borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                        ...cellStyle,
                      }}
                    >
                      {row[col.dataIndex] ?? "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}

              {/* ================= TOTAL ROW ================= */}
              {totalRow && (
                <TableRow sx={{ backgroundColor: "#f5f8ff" }}>
                  {columnData.map((col, index) => (
                    <TableCell
                      key={`total-${index}`}
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                        ...cellStyle,
                      }}
                    >
                      {col.dataIndex === "preference"
                        ? "TOTAL"
                        : col.dataIndex === "candidate_count"
                        ? totalRow[col.dataIndex]
                        : ""}
                    </TableCell>
                  ))}
                </TableRow>
              )}
            </>
          ) : (
            <TableRow>
              <TableCell
                colSpan={columnData.length}
                sx={{
                  textAlign: "center",
                  color: cssProperties.bordercolor.primary2blue,
                }}
              >
                No Result Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
